import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { messages } from "../views/Job/Job.messages";
import ToggleChatButton from "./ToggleChatButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import MessageCenterModal from "../views/Job/components/Modals/MessageCenterModal";
import { useNavigate } from "react-router-dom";
import useMessages from "../hooks/useMessages";
import useUserAccount from "../hooks/useUserAccount";

const JobSupport = (props) => {
    const navigate = useNavigate();
    const [showMessageCenterModal, setShowMessageCenterModal] = useState(false);
    const [clearMessageCenterModal, setClearMessageCenterModal] = useState(false);
    const [messageCenterAlertDialog, setMessageCenterAlertDialog] = useState({});
    const { createTicket } = useMessages();
    const { userName } = useUserAccount();
    const lng = props.intl.formatMessage;

    const toggleMessageCenterModal = () => {
        setShowMessageCenterModal(!showMessageCenterModal);
    }

    /**
     * Submit a new conversation from job.
     *
     * @param {*} formData
     */
    const submitNewMessageCenterConversation = async (formData)=> {
        setClearMessageCenterModal(false);
        props.toggleLoading(true, lng(messages.actionSaving));
        try {
            await createTicket(formData);
            props.toggleLoading(false);
            // close message center modal and show success message in invoice page
            setClearMessageCenterModal(true);
            const alert = { message: lng(messages.messageIsSent), type: 'success' };
            navigate("/messagecenter", { state: { fromJob: true, alert}});
        } catch (error) {
            props.toggleLoading(false);
            // show alert in MessageCenterModal without closing the modal
            setMessageCenterAlertDialog({
                message: lng(messages.titleSavingFailed) + ". " + lng(messages.pleaseTryAgain),
                type: 'danger',
                show: true
            });
        }
    }

    const tooltipContent = () => {
        if (!props.messageCenterAuthorized){
            return (
                <Tooltip id='maintenance-ongoing'>
                    {lng(messages.loginToSendMessage)}
                </Tooltip>
            );
        } else if (props.maintenance) {
            return (
                <Tooltip id='maintenance-ongoing'>
                    { lng(messages.underMaintenance) }
                </Tooltip>
            );
        } else if (!props.showNewMessageButton) {
            return (
                <Tooltip id='maintenance-ongoing'>
                    { lng(messages.ongoingMessaging) }
                </Tooltip>
            );
        } else {
            return (<></>);
        }
    }

    return (
        <Card className='fullwidth-mobile grey-bottom-border-mobile'>
            <Card.Body>
                <h3 id="get-support-title">{lng(messages.getSupport)}</h3>
                <ul className='list-unstyled job-actions'>
                    {props.showChatButton && props.livechatParameters !== null && (
                        <li>
                            <span className='label'>
                                <ToggleChatButton
                                    visitor={{ name: userName(), email: '' }}
                                    parameters={props.livechatParameters}
                                />
                            </span>
                        </li>
                    )}
                    {props.showMessageCenterButton && (
                        <li>
                            <span className='label '>
                                <OverlayTrigger
                                    key='show-maintenance-ongoing'
                                    trigger={['hover', 'click']}
                                    rootClose={true}
                                    placement='top'
                                    overlay={tooltipContent()}
                                >
                                    <Button
                                        className={props.maintenance || !props.showNewMessageButton || !props.messageCenterAuthorized ? 'show-mandate listbutton-disabled actionlist-button' : ' show-mandate actionlist-button'}
                                        variant='tertiary'
                                        onClick={() => {
                                            if (!props.maintenance && props.showNewMessageButton) {
                                                toggleMessageCenterModal();
                                            }
                                        }}
                                        aria-label={lng(messages.createNewMessage)}
                                    >
                                        <FontAwesomeIcon icon={far.faEnvelopeOpenText} aria-hidden="true" />
                                        {lng(messages.createNewMessage)}
                                        <span className='float-end' aria-hidden="true">
                                            <FontAwesomeIcon icon={far.faChevronRight} />
                                        </span>
                                    </Button>
                                </OverlayTrigger>
                            </span>
                        </li>
                    )}
                </ul>
                {props.messageCenterAuthorized && (
                    <MessageCenterModal
                        show={showMessageCenterModal}
                        hide={toggleMessageCenterModal}
                        handleSubmit={submitNewMessageCenterConversation}
                        jobid={props.job.jobid}
                        statuscode={props.job.statuscode}
                        alert={messageCenterAlertDialog}
                        clearMessageCenterModal={clearMessageCenterModal}
                    />
                )}
            </Card.Body>
        </Card>
    )
}

JobSupport.propTypes = {
    intl: PropTypes.object.isRequired,
    showChatButton: PropTypes.bool,
    showMessageCenterButton: PropTypes.bool,
    showNewMessageButton: PropTypes.bool,
    livechatParameters: PropTypes.array,
    maintenance: PropTypes.bool,
    messageCenterAuthorized: PropTypes.bool,
    job: PropTypes.object,
    toggleLoading: PropTypes.func
}

export default injectIntl(JobSupport);